export * from './StaticCards';
